import * as WebBrowser from "expo-web-browser";
import { getQueryKey } from "@trpc/react-query";
import type { DataSession } from "../../data/core/session";
import { trpc } from "@utils/trpc";
export async function openEnginePayment(
  data: DataSession,
  url: string,
  hold?: { accessId: string; clientSecret: string },
  openBrowser = WebBrowser.openAuthSessionAsync,
) {
  const handoff = await data.api.identity.checkoutHandoff.mutate({
    url,
  });
  try {
    await openBrowser(handoff.url, "lsn://checkout-return");
  } finally {
    // However the browser closed, an unpaid session's hold goes back now; a
    // paid one is left alone by the engine side.
    if (hold)
      void data.api.accesses.releaseEngineCheckout
        .mutate(hold)
        .catch(() => undefined);
    // A return is not proof of issuance. The projection owns wallet contents.
    await refreshAccesses(data);
  }
}

/** The fan's accesses and the access itself, read again: after a checkout
 *  (hosted or native) the Details screen shows the tickets once issued. */
export async function refreshAccesses(data: DataSession) {
  const { queryClient } = data;
  await queryClient.invalidateQueries({
    queryKey: getQueryKey(trpc.user.accesses.listUserAccesses),
    refetchType: "all",
  });
  await queryClient.invalidateQueries({
    queryKey: getQueryKey(trpc.accesses.getById),
  });
}
